import React, { useEffect, useState } from "react";
import { calculateDistance } from "../../utils/geo";
import { useSelector } from "react-redux";
import GoogleMapView from "../GoogleMapView";
import "./AppelOffreCard.css";
const AppelOffreCard = ({ project, onLike, onPass, isReceivedLike = false, isAlreadyMatch = false, isLikeSent = false }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { user } = useSelector((state) => state.auth);
  const [realDistance, setRealDistance] = useState(null);
  const [duration, setDuration] = useState(null);

  useEffect(() => {
    if (
      !user?.profilPrestataire ||
      !project?.latitudeProjet ||
      !project?.longitudeProjet
    )
      return;

    const fetchDistance = async (originLat, originLng, destLat, destLng) => {
      try {
        const res = await fetch(
          `${apiUrl}/api/maps?originLat=${originLat}&originLng=${originLng}&destLat=${destLat}&destLng=${destLng}`
        );
        const data = await res.json();

        if (data) {
          setRealDistance(data.distance_text);
          setDuration(data.duration_text);
        }
      } catch (err) {
        console.error("Erreur récupération distance :", err);
      }
    };

    fetchDistance(
      user.profilPrestataire.latitudePrestataire,
      user.profilPrestataire.longitudePrestataire,
      project.latitudeProjet,
      project.longitudeProjet
    );
  }, [project, user]);

  return (
    <div className="project-card">
      <div className="project-header">
        <h2>{project.titreProjet}</h2>
        <span className="sector">{project.secteurProjet}</span>
      </div>

      <p className="description">{project.descriptionProjet}</p>

      <div className="project-info">

        <p>
          <strong>Localisation :</strong> {project.villeProjet} (
          {project.codePostalProjet}, {project.paysProjet})
        </p>

        <p>
          <strong>Distance à vol d’oiseau :</strong>{" "}
          {calculateDistance(
            project.latitudeProjet,
            project.longitudeProjet,
            user.profilPrestataire.latitudePrestataire,
            user.profilPrestataire.longitudePrestataire
          )}{" "}
          km
        </p>
        {realDistance && (
          <p>
            <strong>Distance réelle :</strong> {realDistance} ({duration})
          </p>
        )}
        {user?.profilPrestataire && (
          <GoogleMapView
            origin={{
              lat: user.profilPrestataire.latitudePrestataire,
              lng: user.profilPrestataire.longitudePrestataire,
            }}
            destination={{
              lat: project.latitudeProjet,
              lng: project.longitudeProjet,
            }}
          />
        )}

        <p>
          <strong>Télétravail possible :</strong>{" "}
          {project.isRemotePossible ? "Oui" : "Non"}
        </p>
        <p>
          <strong>Status :</strong> {project.statusProjet}
        </p>
      </div>

      <div className="project-besoins">
        <h4>Besoins :</h4>
        {project.besoinsProjet.map((b) => (
          <div key={b.idBesoinProjet} className="besoin">
            <span className="metier">{b.metier.labelMetier}</span>
            <span className="nb">
              ({b.nbPersonnes} personne{b.nbPersonnes > 1 ? "s" : ""})
            </span>
          </div>
        ))}
      </div>

      {project.photosProjet.length > 0 && (
        <div className="photos">
          {project.photosProjet.map((photo, i) => (
            <img
              key={i}
              src={`${apiUrl}/api/files/?categorie=projets&file=${photo.fileNameFileProjet}`}
              alt={`photo-${i}`}
            />
          ))}
        </div>
      )}
      {
        !isAlreadyMatch && !isLikeSent && (
          <div className="actions">
            {!isReceivedLike ? (
              <>
               
                <button
                  className="like"
                  onClick={() => onLike(project.idProjet)}
                >
                  👍 Like
                </button>
              </>
            ) : (
              <>
                <button
                  className="pass"
                  onClick={() => onPass(project.idProjet)}
                >
                  ❌ Refuser le match
                </button>
                <button
                  className="like"
                  onClick={() => onLike(project.idProjet)}
                >
                  💌 Confirmer le match
                </button>
              </>
            )}
          </div>
        )
      }

    </div>
  );
};

export default AppelOffreCard;
